import type { ReactNode } from 'react';

import { use, useMemo } from 'react';

import useSelectedSpace from '../../../hooks/useSelectedSpace';

import { HouseIcon } from '../../../images/shapes';

import Breadcrumbs from '../../Breadcrumbs/Breadcrumbs';
import { TopbarContext } from '../Topbar';

interface TopbarBreadcrumbsProps {
  /**
   * Page title
   */
  title?: ReactNode;
  /**
   * Parent page title
   */
  parentTitle?: ReactNode;
  /**
   * Link to parent page
   */
  parentLink?: string;
}

const TopbarBreadcrumbs = ({
  title = '',
  parentTitle,
  parentLink,
}: TopbarBreadcrumbsProps) => {
  const { buildUrlWithSpace } = useSelectedSpace();
  const { pageTitle } = use(TopbarContext);

  const breadcrumbs = useMemo(
    () => [
      {
        label: <HouseIcon className="w-3 text-blue" />,
        link: buildUrlWithSpace(''),
        additionalClasses: 'text-slate-400 text-center shrink-0',
        key: 'home',
      },
      ...(parentTitle
        ? [
            {
              label: parentTitle,
              link: parentLink,
              additionalClasses: 'text-slate-400 truncate text-center',
              key: 'parent',
              disabled: !parentLink,
            },
          ]
        : []),
      {
        label: title || pageTitle,
        additionalClasses: 'text-slate-600 truncate',
        disabled: true,
        key: 'form',
      },
    ],
    [buildUrlWithSpace, parentTitle, parentLink, title, pageTitle],
  );

  return (
    <Breadcrumbs breadcrumbs={breadcrumbs} additionalClasses="p-0 mt-0.5" />
  );
};

export default TopbarBreadcrumbs;
